export function infoStatusDesc(status) {
    if (status == 4) {
        return '已完成必填项'
    } else if (status ==5) {
        return '未完成必填项'
    } else {
        return '未填写'
    }
}


// WEBPACK FOOTER //
// ./src/components/mycenter_studyabroad/HBCommon/util.js